import { useAtomValue, useSetAtom } from "jotai";
import { redirectAtom } from "../../store";

export const useRedirect = () => {
  return useAtomValue(redirectAtom);
};

export const useSetRedirect = () => {
  const setRedirectUrl = useSetAtom(redirectAtom);

  return setRedirectUrl;
};
